import { render, staticRenderFns } from "./DashboardHeader.vue?vue&type=template&id=7e8b85c8&scoped=true"
import script from "./DashboardHeader.vue?vue&type=script&lang=js"
export * from "./DashboardHeader.vue?vue&type=script&lang=js"
import style0 from "./DashboardHeader.vue?vue&type=style&index=0&id=7e8b85c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8b85c8",
  null
  
)

export default component.exports